export const PAGINATION_DEFAULT_START_PAGE = 1;
export const PAGINATION_DEFAULT_ROWS_PER_PAGE = 5;
export const PAGINATION_DEFAULT_ROWS_PER_PAGE_MAIN = 10;
export const PAGINATION_ASC = 'asc';
export const PAGINATION_DESC = 'desc';
